import React, {ReactElement} from 'react';
import {
  makeStyles,
  InputAdornment,
  OutlinedInputProps
} from '@material-ui/core';
import {Search as SearchIcon} from '@material-ui/icons';
import StyledOutlinedInput from './StyledOutlinedInput';
const useStyles = makeStyles(() => ({
  searchBar: {
    '& .MuiInputBase-inputTypeSearch': {
      height: '0.5rem'
    },
    '& .MuiOutlinedInput-adornedStart': {
      backgroundColor: 'white'
    },
    '& .MuiTextField-root': {
      marginBottom: 0,
      paddingBottom: 0
    }
  },
  root: {
    color: 'black'
  }
}));
const SearchField = (props: OutlinedInputProps): ReactElement => {
  const classes = useStyles();
  return (
    <StyledOutlinedInput
      id="outlined-search"
      type="search"
      className={[classes.searchBar, classes.root].join(' ')}
      fullWidth={true}
      color="secondary"
      margin="none"
      placeholder={'From date'}
      {...props}
      // @ts-ignore
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
    />
  );
};
export default SearchField;